import { ApiResponse, HTTPVerb } from '../Modules/Utils/API/Interfaces/IApi';
import { ApiManager } from '../Modules/Utils/API/ApiManager';

enum APIConstants {
    Logout = '/api/Logout/',
}

export interface ILogoutDataRequest {
    IsManuelLogout?: boolean;
    KickReasonId?: number;
    IsLogoutFromPlatform?: boolean;
}

export default class LogoutApi {
    public static Logout = async (data: ILogoutDataRequest): Promise<ApiResponse<any>> => {
        return ApiManager.getAPIInstance().authenticatedRequest({
            url: APIConstants.Logout,
            method: HTTPVerb.POST,
            data,
        });
    };
}
